import { DefaultDatePicker } from '@/components/common/DatePicker';
import { dueDateTimeSlots } from '@/components/tour/notes/data';
import { getUnoccupiedTimeslots } from '../utils/due-date';
import { useNotesStore } from '@/components/tour/notes/stores/notes.store';

type Props = {
  dueDate: Date;
  assigneeId: string;
  backlogEnabled: boolean;
  onChange: (date: Date) => void;
  availableFrom: Date;
  noteId?: number;
};

export function DueDateSelect({
  dueDate,
  onChange,
  backlogEnabled,
  availableFrom,
  assigneeId,
  noteId,
}: Props) {
  const notes = useNotesStore((store) => store.notes);

  return (
    <DefaultDatePicker
      value={dueDate}
      onChange={onChange}
      disableDaysBefore={availableFrom}
      shouldDisableDay={(day) => {
        if (!backlogEnabled) {
          const weekDay = day.date.day();

          const isWeekend = weekDay === 0 || weekDay === 6;
          return isWeekend;
        }

        return false;
      }}
      shouldDisableTime={(minutes) => {
        const availableTimeSlots = getUnoccupiedTimeslots(dueDate, {
          notes: notes.filter((n) => {
            if (typeof noteId !== 'number') return true;
            return n.id !== noteId;
          }),
          assigneeId,
          timeSlots: dueDateTimeSlots,
        });

        if (!backlogEnabled) {
          return !availableTimeSlots.includes(minutes);
        }

        return false;
      }}
      timeSlots={dueDateTimeSlots}
    />
  );
}
